<template>
  <div>
    <h1>Start:</h1>
    <v-responsive
      class="mx-auto"
      max-width="344"
    >
      <v-text-field
        hide-details="auto"
        label="Search Location"
      />
    </v-responsive>
    <div class="get_information_button">
      <v-btn
        style="margin-bottom: 20px;"
        @click="loadInitializeClientAndStartSearch"
      >
        Search
      </v-btn>
    </div>
    <div
      v-for="suggestion in suggestions"
      :key="suggestion.displayName"
    >
      <PlaceSuggestion
        style="margin-bottom: 20px;"
        :info="suggestion"
      />
    </div>
  </div>
</template>
<script>
import PlaceSuggestion from './PlaceSuggestion.vue';
export default {
  components: {
    PlaceSuggestion
  },
  data() {
    return {
      start: "",
      end: "",
      place: null,
      latitude: 35.660054,
      longitude: 139.751084,
      radius: 5000,
      suggestions: null,
    };
  },
  async mounted() {
    let googleApiScript = document.createElement("script");
    googleApiScript.setAttribute("src", "https://apis.google.com/js/api.js");
    document.head.appendChild(googleApiScript);
  },
  methods: {
    async loadInitializeClientAndStartSearch() {
      gapi.load("client", this.getPlacesSuggestionsUrl);
    },
    async performSearch() {
      const locationRestriction = {
        circle: {
          center: {
            latitude: this.latitude,
            longitude: this.longitude,
          },
          radius: this.radius,
        },
      };

      const request = {
        language_code: "en",
        region_code: "JP",
        included_types: [
          "tourist_attraction",
          "cultural_center",
          "amusement_center",
        ],
        max_result_count: 5,
        location_restriction: locationRestriction,
        rank_preference: "POPULARITY",
      };

      const header = {
        "X-Goog-FieldMask": "places.displayName,places.formattedAddress,places.photos",
      };
      gapi.client
        .request({
          path: "https://places.googleapis.com/v1/places:searchNearby",
          method: "POST",
          body: request,
          headers: header,
        })
        .then(
          (response) => {
            const results = response.result;
            this.suggestions = results.places;
            console.log(results)
          },
          (reason) => {
            console.error("Error: " + reason.result.error.message);
          }
        );
    },
    async getPlacesSuggestionsUrl() {
      gapi.client
        .init({
          apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
          discoveryDocs: [
            "https://places.googleapis.com/$discovery/rest?version=v1",
          ],
        })
        .then(this.performSearch());
    },
  },
};
</script>

<style>
.get_information_button {
  margin-top: 20px;
}
</style>
